export default function genererIndexation(societeId) {
  return {
    annee: null,
    dateDebut: null,
    dateFin: null,
    pourcentageIndexationParDefaut: 0,
    applicableLocation: false,
    applicableTlpe: false,
    applicableDivers: false,
    applicableHonoraire: false,
    indexationTiers: [],
    societeId: societeId,
  };
}
